var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 7,
    viewBox: "0 0 62 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 3.5L57 0.613249V6.38675L62 3.5ZM0 4H57.5V3H0V4Z",
    fill: "url(#paint0_linear_2341)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2341",
    x1: 74.5,
    y1: 3.50052,
    x2: -0.46828,
    y2: 2.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054B7D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47659,
    stopColor: "#054B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054B7D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowGradient);
export default __webpack_public_path__ + "static/media/rightArrow_gradient.6e627b71f8d6c540fcb5f1750b604118.svg";
export { ForwardRef as ReactComponent };